// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kQSQz","right":"styles_right__2C0w-"};